/**
 * sessaoAba — marca de "MFA verificado nesta sessão" guardada na `sessionStorage` da aba,
 * ao lado dos tokens do SDK (ADR-031). Só o caminho do desafio TOTP grava a marca; o
 * logout a remove. Sem `sessionStorage` disponível, nada é guardado (a sessão não
 * sobrevive ao F5 — comportamento anterior). Nenhum dado pessoal é gravado.
 */

const CHAVE_MFA = 'acervo.sessao.mfaVerificado';

export function marcarMfaVerificado(): void {
  try {
    window.sessionStorage.setItem(CHAVE_MFA, '1');
  } catch {
    // aba sem sessionStorage: a marca vive só na memória do AuthProvider
  }
}

export function mfaVerificadoNaAba(): boolean {
  try {
    return window.sessionStorage.getItem(CHAVE_MFA) === '1';
  } catch {
    return false;
  }
}

export function limparMarcaMfa(): void {
  try {
    window.sessionStorage.removeItem(CHAVE_MFA);
  } catch {
    // ignora
  }
}
